import { render, staticRenderFns } from "./pfqd.vue?vue&type=template&id=71a0c8e6&scoped=true&"
import script from "./pfqd.vue?vue&type=script&lang=js&"
export * from "./pfqd.vue?vue&type=script&lang=js&"
import style0 from "./pfqd.vue?vue&type=style&index=0&id=71a0c8e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a0c8e6",
  null
  
)

export default component.exports